import { SelectModel } from "@/core/domain/models/components/inputs/select.model";
import { TypeInputDataEnum } from "../enums/type-input-data.enum";

export class ConfirmInputDataModel {
    message: string = '';
    value?: any;
    labelInput: string;
    typeInput: TypeInputDataEnum;
    maskInput?: string;
    options?: Array<SelectModel> = [];
    canCancel: boolean = true;
}